module.exports = __webpack_public_path__ + "media/site_templates/www.mulchingservices.net.au/images/our_services_2-f69cca6c5df30ee54a296488825435ba.jpg";